export let LostSessionErrorType = /*#__PURE__*/function (LostSessionErrorType) {
  LostSessionErrorType["SESSION_INVALID"] = "SESSION_INVALID";
  LostSessionErrorType["CONCURRENT_SESSION_INVALID"] = "CONCURRENT_SESSION_INVALID";
  LostSessionErrorType["CONCURRENT_SESSION_DISABLED"] = "CONCURRENT_SESSION_DISABLED";
  LostSessionErrorType["BROWSER_TAB_STOLEN_SESSION"] = "BROWSER_TAB_STOLEN_SESSION";
  return LostSessionErrorType;
}({});
//# sourceMappingURL=IAuthenticationService.js.map
